<template>
  <div class="box9" id="box9">
    <pageTitle
      title="真实学员就业展示"
      text="见证技术实力与职业成长"
      titleColor="#000D4D"
      titColor="#5A628A"
    />

    <div class="content">
      <div class="border">
        <div class="content-top">
          <div class="name">姓名</div>
          <div class="age">年龄</div>
          <div class="edu">学历</div>
          <div class="pre-school">学前职业</div>
          <div class="after-salary">就业薪资</div>
          <div class="city">入职城市</div>
          <div class="company">就职公司</div>
        </div>
      </div>
      <div class="swiper-box">
        <swiper :options="swiperOption" ref="mySwiper" class="swiperitems1">
          <swiper-slide
            class="swiperwrap"
            v-for="(item, index) in salaryList"
            :key="index"
          >
            <div class="item" v-for="(item, index) in salaryList" :key="index">
              <div class="name">{{ item.name }}</div>
                <div class="age">{{ item.age }}</div>
                <div class="edu">{{ item.edu }}</div>
                <div class="pre-school">{{ item.preSchool }}</div>
                <div class="after-salary">{{ item.afterSalary }}</div>
                <div class="city">{{ item.city }}</div>
                <div class="company">{{ item.company }}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="tips">* 为了避免对学员造成影响，以上数据做了部分隐藏处理，<br/>
      相关数据来源于公司内部真实统计<br/>
      *鸿蒙就业班为24年7⽉新上线产品，就业数据截止25年3月初</div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },

  data() {
    return {
      swiperOption: {
        // swiper配置
        direction: "vertical", // 滑动方向改为垂直
        height: 72, //你的slide高度 强制性 垂直方向生效
        loop: true, //是否循环
        freeMode: true,
        speed: 30000,
        autoplay: {
          delay: 0, // 自动播放的时长
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        grabCursor: true,
        slidesPerView: "auto",
      },
      salaryList: [
        {
          name: "向同学",
          age: "25",
          edu: "专科",
          preSchool: "建筑建模",
          afterSalary: "11000",
          city: "十堰",
          company: "上海****科技有限公司",
        },
        {
          name: "燕同学",
          age: "26",
          edu: "专科",
          preSchool: "其它",
          afterSalary: "12500",
          city: "北京",
          company: "****信息技术股份有限公司",
        },
        {
          name: "刘同学",
          age: "22",
          edu: "专科",
          preSchool: "电商",
          afterSalary: "13000",
          city: "深圳",
          company: "上海****科技有限公司",
        },
        {
          name: "梁同学",
          age: "26",
          edu: "本科",
          preSchool: "售前技术支持",
          afterSalary: "14600",
          city: "广州",
          company: "****信息技术股份有限公司",
        },
        {
          name: "杨同学",
          age: "23",
          edu: "本科",
          preSchool: "/",
          afterSalary: "10000",
          city: "远程",
          company: "北京****信息技术有限公司",
        },
        {
          name: "朱同学",
          age: "24",
          edu: "本科",
          preSchool: "其它",
          afterSalary: "11000",
          city: "杭州",
          company: "杭州****科技有限公司",
        },
        {
          name: "胡同学",
          age: "23",
          edu: "本科",
          preSchool: "/",
          afterSalary: "15000",
          city: "重庆",
          company: "北京****信息技术有限公司",
        },
        {
          name: "李同学",
          age: "22",
          edu: "本科",
          preSchool: "Python开发",
          afterSalary: "7000",
          city: "武汉",
          company: "武汉****科技有限公司",
        },
        {
          name: "刘同学",
          age: "28",
          edu: "本科",
          preSchool: "化工",
          afterSalary: "15000",
          city: "上海",
          company: "****集团",
        },
        {
          name: "王同学",
          age: "22",
          edu: "本科",
          preSchool: "学生",
          afterSalary: "12000",
          city: "北京",
          company: "****信息技术股份有限公司",
        },
        {
          name: "陆同学",
          age: "26",
          edu: "本科",
          preSchool: "/",
          afterSalary: "14300",
          city: "东莞",
          company: "****成技术",
        },
        {
          name: "朱同学",
          age: "28",
          edu: "本科",
          preSchool: "/",
          afterSalary: "12000",
          city: "武汉",
          company: "武汉****科技有限公司",
        },
        {
          name: "林同学",
          age: "29",
          edu: "本科",
          preSchool: "/",
          afterSalary: "16000",
          city: "北京",
          company: "北京****信息技术有限公司",
        },
        {
          name: "马同学",
          age: "29",
          edu: "本科",
          preSchool: "人工智能",
          afterSalary: "22500",
          city: "北京",
          company: "北京****信息技术有限公司",
        },
      ],
      list: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      swiperOption2: {
        loop: true, // 循环模式选项

        spaceBetween: 22,
        autoplay: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          slideShadows: true, // 页面阴影效果
          rotate: 0, // 旋转的角度
          stretch: 50, // 拉伸   图片间左右的间距和密集度
          depth: 200, // 深度   切换图片间上下的间距和密集度
          modifier: 0.9, // 修正值 该值越大前面的效果越明显
        },
        pagination: {
          el: ".swiper-pagination-box12",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box9 {
  padding: 80px 0 88px;

  width: 100%;
  background: #E4E9FF;
  /deep/ .swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: linear; /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
  }

  .content {
    width: 750px;
    height: 975px;
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 48px;

    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);

    .border {
      margin: 0 30px;
      width: 1010px;
    }
    .swiper-box {
      margin: 0 30px;
      width: 1010px;
      height: 905px;
      border-radius: 0 0 24px 24px;
      overflow: hidden;
    }
    .swiperitems1 {
      
      width: 1010px;
      box-sizing: border-box;
    }
    .swiperwrap {
      border-radius: 0 0 24px 24px;
      background-color: #ffffff !important;
      position: relative;
      z-index: 20;
    }
    .item {
      width: 1010px;
      display: flex;
      text-align: center;
      height: 96px;
      background: #ffffff;
      line-height: 96px;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #4e5969;
      box-sizing: border-box;
      border-bottom: 2px solid rgba(232, 243, 255, 0.8);
    }
    .name {
      width: 120px;
      height: 70px;
      border-radius: 24px 0 0 0;
    }
    .age {
      width: 90px;
      height: 70px;
    }
    .edu {
      width: 90px;
      height: 70px;
    }
    .pre-school {
      width: 160px;
      height: 70px;
    }
    .after-salary {
      width: 150px;
      height: 70px;
      color: #165dff;
    }
    .city {
      width: 150px;
      height: 70px;
    }
    .company {
      width: 310px;
      height: 70px;
    }

    .content-top {
      width: 1010px;
      display: flex;
      height: 70px;
      box-sizing: border-box;
      background: linear-gradient(0deg, #8DCAFC 0%, #346BF1 100%);
      border-radius: 24px 24px 0 0;
      div {
        // flex: 1;
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 70px;
      }
    }
  }

  .swiper-content {
    position: relative;
    padding-bottom: 38px;
    margin-top: 80px;

    img {
      padding: 4px;
      width: 406px;
      height: 662px;
      background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
      transition: all 0.3s;
    }

    .swiper-slide {
      display: flex;
      align-items: center;
      padding: 4px;
      width: 411px;
      height: 728px;
      background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
    }
    .swiper-slide-active {
      img {
        width: 450px;
        height: 736px;
        border-radius: 24px;
        margin-left: -20px;
      }
    }
    .swiper-pagination-box12 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 0px);
      background: rgba(46, 165, 252, 0.16);
      // width: 60px;
      // height: 6px;

      // // background: #70c3f7;
      // background: rgba(46, 165, 252, 0.16);
      // border-radius: 3px;
    }
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }
  .tips {
    margin-top: 22px;
    font-size: 22px;
    color: #9BA4B4;
    line-height: 38px;
    text-align: center;
  }
}
</style>
